<div class="scheduler-settings-container">
    <mat-card class="mat-elevation-z0 tasks-header-container">
        <mat-card-title class="tasks-header-label">Jobs</mat-card-title>
        <div class="scheduler-actions">
            <app-scheduler-status></app-scheduler-status>
            <button mat-raised-button color="accent" class="scheduler-settings-button"
                (click)="openSchedulerSettings()">Scheduler
                Settings</button>
            <app-stop-all-processes-button [stopJobs]="true"></app-stop-all-processes-button>
            <app-remove-selected-processes *ngIf="isActiveJobsTabActive" [processesList]="jobs$|async">
            </app-remove-selected-processes>
            <app-archive-selected-processes *ngIf="isActiveJobsTabActive" [processesList]="jobs$|async"
                class="processes-action-button">
            </app-archive-selected-processes>
            <app-remove-selected-processes *ngIf="!isActiveJobsTabActive" [processesList]="archivedJobs$|async">
            </app-remove-selected-processes>
            <app-archive-selected-processes *ngIf="!isActiveJobsTabActive" [processesList]="archivedJobs$|async"
                class="processes-action-button" [restore]="true">
            </app-archive-selected-processes>
        </div>
    </mat-card>
    <mat-tab-group class="mat-elevation-z0" #tabs mat-stretch-tabs="false">
        <mat-tab label="Jobs">
            <app-paginated-jobs-list #activeJobs [jobs$]="jobs$" [totalJobsCount]="totalActiveJobsCount"
                [getArchived]="false" [pageChanged]="pageChanged.bind(this)" [hideAddButton]="true"
                [showSelectedColumn]="true" [searchParamsChanged]="searchParamsChanged.bind(this)">
            </app-paginated-jobs-list>
        </mat-tab>

        <mat-tab label="Archived Jobs">
            <app-paginated-jobs-list #archivedJobs [jobs$]="archivedJobs$" [totalJobsCount]="totalArchivedJobsCount"
                [getArchived]="true" [pageChanged]="pageChanged.bind(this)" [hideAddButton]="true"
                [showSelectedColumn]="true" [searchParamsChanged]="searchParamsChanged.bind(this)">
            </app-paginated-jobs-list>
        </mat-tab>
    </mat-tab-group>

</div>
<app-spinner [showOverlay]="false" *ngIf="showSpinner"></app-spinner>